import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

const AutoUpdateLineItemsModal = props => {
	const { lang } = global;
	const { show, isEstimate, changedJobEvents, onSuccess, onCancel } = props;
	const type = lang.t(isEstimate ? "Estimate" : "Invoice").toLowerCase();

	return (
		<Modal
			id="missing-timecard-modal"
			show={show}
			onHide={() => onCancel()}
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Job(s) Changed")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Choose>
					<When condition={changedJobEvents.length > 0}>
						<p>{lang.t("The following jobs have changed_")}</p>
						<ul>
							<For
								each="job"
								of={changedJobEvents}
							>
								<li key={`changedjob-${job.id}-${job.assignmentId}`}>
									<a
										href={`/jobs/${job.id}`}
										target="_blank"
										rel="noopener noreferrer"
									>
										{job.name} ({job.id})
									</a>
								</li>
							</For>
						</ul>
						{lang.t("dynamic.Update manual invoice items_", { type })}
					</When>
					<Otherwise>
						<p className="text-center">
							{lang.t("dynamic.Manual invoice jobs deleted", { type })}
						</p>
						<p className="text-center">
							{lang.t("dynamic.Manual invoice no longer valid", { type })}
						</p>
					</Otherwise>
				</Choose>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={() => onCancel()}
				>
					{changedJobEvents.length > 0 ? lang.t("Cancel") : lang.t("OK")}
				</button>
				<If condition={changedJobEvents.length > 0}>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => onSuccess()}
					>
						{lang.t("Apply")}
					</button>
				</If>
			</Modal.Footer>
		</Modal>
	);
};

AutoUpdateLineItemsModal.propTypes = {
	show: PropTypes.bool,
	isEstimate: PropTypes.bool,
	changedJobEvents: PropTypes.array,
	onSuccess: PropTypes.func,
	onCancel: PropTypes.func,
};

AutoUpdateLineItemsModal.defaultProps = {
	show: false,
	isEstimate: false,
	changedJobEvents: [],
	onSuccess: () => {},
	onCancel: () => {},
};

export default AutoUpdateLineItemsModal;
